import { ChangeDetectorRef, Component } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { LoggerService, LogPage, LogType } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { WidgetHostBaseComponent } from '../../shared/widget/widgethostbase.component';

@Component({
    selector: 'app-content-page',
    templateUrl: './content-page.component.html',
    styleUrls: ['./content-page.component.scss'],
    standalone: false
})
export class ContentPageComponent {

    constructor(
        logger: LoggerService,
        public profileService: ProfileService,
        auth: AuthenticationService,
        changeDetector: ChangeDetectorRef
    ) {
        //super("TilePageComponent", profile, logger, LogType.Page, LogPage.Courses, changeDetector);
    }
}
